import { CATALOG } from './catalog';
import { useModuleTree } from './store';

const CATALOG_INK = new Map(CATALOG.modules.map((m) => [m.id, m.ink]));

/**
 * The module inks the tenant chose (Admin ▸ Modules) and the team modules'
 * inks, as CSS. `tokens.css` writes one `[data-mod='<id>']` rule per catalog
 * module (CSS cannot read the config); this adds a rule for every module
 * whose ink is not the catalog's, so the rail, the switcher and the light
 * behind the pages follow the tenant's choice. Inks are token names from the
 * curated list (validated on both sides), ids are slugs: nothing free-form
 * reaches the stylesheet.
 *
 * An unchanged tree (Asian Trails) renders nothing at all.
 */
export function ModuleInkStyle() {
  const tree = useModuleTree();
  const rules: string[] = [];
  for (const m of tree.modules) {
    if (CATALOG_INK.get(m.id) === m.ink) continue;
    if (!/^[a-z][a-z0-9-]*$/.test(m.id) || !/^--[a-z][a-z0-9-]*$/.test(m.ink)) continue;
    rules.push(`html [data-mod='${m.id}'] { --module-accent: var(${m.ink}); }`);
  }
  if (!rules.length) return null;
  return <style data-module-inks="">{rules.join('\n')}</style>;
}
